<template>
  <div class="addnewmodal" v-show="showModal">
    <div class="addnewmodal__modal" :id="'modal_'+modalId" aria-hidden="true" :class="{modal_open : showModal}" >
      <div class="addnewmodal__overlay" @click="closeCurrentModal()" :class="{modal_open : showModal}">
      </div>
      <div class="modal-dialog">
        <div class="modal-header">
          <h2>{{ modalTitle}}</h2>
          <button @click="closeCurrentModal()" class="btn-x-close" aria-hidden="true"><i class="material-icons">clear</i></button>
        </div>
        <div class="modal-body">
          <div class="wrapper-language-select" :id="'input_'+modalId">
            <v-select :items="getItems()" class="lang-select"
                      v-model="selectedLanguage"
                      label="Languages"
                      :attach="'#input_'+modalId+' .v-input__slot'"></v-select>
          </div>
          <!--<div class="p-input">
            <input type="text" :name="'modal_'+modalId+'_text'" :id="'modal_'+modalId+'_text'" class="form-modal__input" placeholder="Language" />
            <p v-if="this.newDataInput === ''">The field is empty, please fill it out</p>
            <p v-if="this.languageIsNotValid()">{{this.nameError}}</p>
          </div>-->

          <button :enable="disableButton" @click="addNewData()" :id="'modal_'+modalId+'_btn'" :name="'modal_'+modalId+'_btn'" class="submit_btn" ><i class="material-icons">save</i><span class="title">Add New {{ modalName }}</span></button>
        </div>
        <div class="modal-footer">
          <button @click="closeCurrentModal()" id="close_modal"  class="btn close_btn"><i class="material-icons">clear</i><span class="title">Close</span></button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { appActions } from '@/constants/'
import ApiService from '@/services/ApiService'

const { mapState } = createNamespacedHelpers('applicationState')

export default {
  name: 'theaddnewmodal',
  props: {
    modalId: String,
    modalData: String,
    modalTitle: String,
    modalType: String,
    modalName: String,
    showModal: Boolean,
    documentLanguages: Array
  },
  data: function () {
    return {
      apiService: new ApiService(),
      newDataInput: ' ',
      isDataEmpty: false,
      nameError: '',
      selectedLanguage: ''
    }
  },
  mounted () {
    // console.log(this.showModal);
  },
  created () {
    // console.log(this.showModal);
  },
  methods: {
    languageIsNotValid () {
      let ret = true
      if (this.selectedLanguage === '') {
        ret = false
      }
      return ret
    },
    addNewData () {
      if (this.selectedLanguage !== '') {
        this.$store.dispatch('applicationState/' + appActions.UPDATE_APP_SETTINGS_DOCUMENT_LIST_ADD_LANGUAGE, { title: this.modalType, language: this.selectedLanguage })
        this.closeCurrentModal(null)
      }
    },
    getItems () {
      let languages = []
      const langarr = this.$i18n.messages
      const usedLangs = this.documentLanguages || []
      for (let lang in langarr) {
        if (usedLangs.find(x => x === lang) !== undefined) {
          continue
        }
        languages.push({ value: lang, text: langarr[lang].message.languageFullName })
      }

      return languages
    },
    closeCurrentModal (evt) {
      this.newDataInput = ' '
      this.$emit('close', false)
    }
  },
  computed: {
    ...mapState({
      appName: state => state.appName,
      appDocumentList: state => state.appDocumentLists,
      disableButton () {
        let ret = true
        if (this.selectedLanguage === '') {
          ret = false
        }
        return ret
      }
    })
  }
}
</script>

<style lang="scss">
  @import '@/scss/main.scss';

  .addnewmodal{
    &__overlay{
      display: none;
      &.modal_open{
        display: block;
      }
        background: rgba(0,0,0,.15);
        position: fixed;
        top: 0; left: 0; right: 0; bottom: 0;
        z-index: 10;
        width: 100vw;
        height: 100vh;
    }
    &__modal{
      display: none;
      &.modal_open{
        display: block;
      }

      &:target{
        // Active animate in modal
        &:before{
          display: block;
        }
        .modal-dialog{
          top: 20%;
        }
      }
    }

      .modal-dialog{
        display: flex;
        flex-flow: column nowrap;
        background: $light;
        border: rgba($dark-light, 0.5) solid 1px;
        border-radius: rem(5);
        position: fixed;
        left: calc(50% - 230px);
        top: 25%;
        z-index: 10;
        min-width: rem(250);
        width: rem(460);
        height: auto;
        transform: translateY(25%);
        transition: transform;
        transition-delay: 0.5;

      }

      .modal-body{
        display: flex;
        flex-flow: column wrap;
        justify-content: space-around;
        padding: rem(40);
        .p-input{
          display: block;
          width: 100%;
          height: rem(32);
          margin: 0 auto rem(24) auto;
          p{
            font-size: rem(12);
            color: $danger;
          }
        }
        .form-modal__input{
            font-size: rem(16);
            border: 1px solid $dark;
            border-radius: rem(5);
            min-width: rem(250);
            width: 100%;
            height: rem(30);
            padding: rem(5);
            background-color: rgba($light, 1);
        }
      }

      .modal-header{
        display: flex;
        flex-flow: row nowrap;
        justify-content: space-between;
        padding: rem(5) rem(16);
        border-bottom: rgba($dark-light, 0.5) solid 1px;
        h2{
          font-size: rem(16);
          font-weight: bold;
          margin: auto rem(20) auto rem(10);
        }
      }

      .modal-footer{
        padding: rem(5);
        border-top: rgba($dark-light, 0.5) solid 1px;
        text-align: right;
      }

      .btn-x-close{
        cursor: pointer;
        border-radius: 100%;
        border: 1px solid rgba($dark-light, 0.8);
        color: $dark;
        padding: rem(4) rem(6);
        .material-icons{
          line-height: rem(20);
        }
      }
      .close_btn {
        background-color: $success;
        color: $light;
      }

      .submit_btn{
        cursor: pointer;
        border-radius: rem(5);
        border: 1px solid rgba($save, 0.8);
        color: $light;
        background-color: rgba($save, 0.8);
        padding: rem(8) rem(14) rem(8) rem(16);

        .title{
            margin-left: rem(8);
            font-size: rem(14);
        }
        .material-icons{
          color: rgba($light, 1);
          left: rem(-14);
          font-size: rem(20);

          &:before{
            top: rem(-14);
            left: rem(-6);
            width: rem(38);
            height: rem(37);
            border-radius: rem(10) 0 0 rem(10);
            border-top-width: 1px;
            border-top-color: $primary;
            border-top-style: solid;
            border-bottom-width: 1px;
            border-bottom-color: $primary;
            border-bottom-style: solid;
            border-left-width: 1px;
            border-left-color: $primary;
            border-left-style: solid;
          }
        }

        &:active {
          transform: translateY(4px);
          transition: 0.2s;
        }
      }

  }

</style>
